export default {
  province_list: {
    330000: '浙江省',
  },
  city_list: {
    330100: '杭州市',
  },
  county_list: {
    330102: '上城区',
    330105: '拱墅区',
    330106: '西湖区',
    330108: '滨江区',
    330110: '余杭区',
  },
};
